"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TwoColumnLayout() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="twocolumnlayout" className="w-full bg-background py-16 px-4 !h-[600px] ![margin:-900px_0px_0px_0px] md:py-24">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 items-center md:grid-cols-2 md:gap-16 lg:gap-20">
          {}
          <div ref={leftRef} className={`relative w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg shadow-medium">
              <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/01/image_vzyujg3g.png" alt="Two column layout visual" className="h-full w-full object-cover ![margin:-50px_0px_-20px_0px]" />
            </div>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <h2 className="font-display font-semibold text-foreground !text-4xl ![margin:-40px_0px_0px_0px]">Our Purpose Serving You</h2>
            <div className="flex flex-col gap-4">
              <p className="text-muted-foreground leading-relaxed !text-xl ![margin:-10px_0px_0px_0px]">Our purpose is to quickly evolve your leadership consciousness, capacity &amp; psychology to have the​ right strategic insights to make the right decisions that creates the right experience for you. <br /><br />Our proven proprietary CEO Breakthrough Protection program enables 3-4x faster buy-in to deals &amp; objectives to protect &amp; enhance progress, company valuation &amp; remuneration while being in great health enjoying more presence &amp; time with family.</p>
              
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}